import { InputBase } from '../../../classes/input-base';
import { InputRadio } from '../../../classes/input-radio';
import { InputText } from '../../../classes/input-text';
import { FeaturesStep4Form } from './features-step4-form';

export class FeaturesStep4FormRedFeather extends FeaturesStep4Form {
	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Url',
		buttonSymbol: 'Go',
		required: true,
		blur: true,
	});

	bookLength = new InputText({
		key: 'bookLength',
		label: 'How many pages is your book?',
		type: 'number',
	});

	nameOfSeries = new InputText({
		key: 'nameOfSeries',
		label: 'What is the name of the series?',
	});

	numberOfBooksInSeries = new InputText({
		key: 'numberOfBooksInSeries',
		label: 'How many books are in the series?',
		type: 'number',
	});

	bookNumber = new InputText({
		key: 'bookNumber',
		label: 'What book number is this book?',
		type: 'number',
	});

	primarySubgenre = new InputText({
		key: 'primarySubgenre',
		label: 'Primary Subgenre',
	});

	threesomesOrRomanticScenes = new InputBase({
		key: 'threesomesOrRomanticScenes',
		label: 'Are there threesomes or romantic scenes with multiple participants in this book?',
		controlType: 'checkbox',
	});

	endingOfBook = new InputRadio({
		key: 'endingOfBook',
		label: 'Please tell us about the ending of the book',
		options: [
			{ id: 'endingHappy', label: 'Happily ever after', value: 'happily-ever-after' },
			{ id: 'endingForNow', label: 'Happily for now', value: 'happily-for-now' },
			{ id: 'endingSeriesHappy', label: 'Series ends Happily Ever After', value: 'series-ends-happily-ever-after' },
			{ id: 'endingMajorCliff', label: 'Major cliffhanger', value: 'major-cliffhanger' },
			{ id: 'endingMinorCliff', label: 'Minor cliffhanger', value: 'minor-cliffhanger' },
			{ id: 'endingNone', label: 'None of these', value: 'none-of-these' },
		],
		value: 'none-of-these',
	});

	cheatingOrInfidelity = new InputBase({
		key: 'cheatingOrInfidelity',
		label: 'Does your book contain cheating or scenes of infidelity?',
		controlType: 'checkbox',
	});

	commonThemes = new InputText({
		key: 'commonThemes',
		label: 'List Common Themes of your Book',
	});

	kindleUnlimited = new InputBase({
		key: 'kindleUnlimited',
		label: 'Is your book enrolled in Kindle Unlimited?',
		controlType: 'checkbox',
	});

	bookPriceDuringPromo = new InputText({
		key: 'bookPriceDuringPromo',
		label: 'Book Price During Promotion',
		required: true,
		type: 'number',
		addonSymbol: '$',
		min: 0,
	});

	bookFree = new InputBase({
		key: 'bookFree',
		label: 'Is this book free?',
		controlType: 'checkbox',
		value: false,
	});

	freeStartDate = new InputBase({
		key: 'freeStartDate',
		label: 'Start Date',
		controlType: 'date',
	});

	freeEndDate = new InputBase({
		key: 'freeEndDate',
		label: 'End Date',
		controlType: 'date',
	});
}
